import { DeviceType as e, getDeviceType as t } from "@magnopus-opensource/magnopus-web-common";
import { createStore as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/vanilla.mjs";
import { persist as r, subscribeWithSelector as i } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
import { handleSubscribers as a } from "@magnopus-opensource/connected-spaces-platform-web-api";
import { TEXTURE_FILTER as o } from "@magnopus-opensource/magnopus-web-renderer/common";
//#region src/local-settings-store/local-settings-store.ts
var s = "__oly_local_settings__", c = 4, l = {
	resolutionScale: 1.5,
	refraction: !1,
	bloom: !1,
	nativeHdrOutput: !1,
	ssao: !1,
	framecap: 0,
	antialias: "msaa2x",
	shadowDistance: "close",
	shadowQuality: "ultra",
	shadowCascades: 1,
	renderer: "webgpu",
	physics: "jolt",
	textureFiltering: {
		min: o.LINEAR_MIPMAP_LINEAR,
		mag: o.LINEAR,
		anisotropy: 16
	}
}, u = {
	bloom: l.bloom,
	nativeHdrOutput: l.nativeHdrOutput,
	ssao: l.ssao,
	refraction: l.refraction,
	resolutionScale: l.resolutionScale,
	antialias: l.antialias,
	shadowDistance: l.shadowDistance,
	shadowQuality: l.shadowQuality,
	shadowCascades: l.shadowCascades,
	renderer: l.renderer,
	framecap: l.framecap,
	physics: l.physics,
	textureFiltering: l.textureFiltering
}, d = { bloom: !0 }, f = { scale: 1 }, p = { intelGraphicsWarningAcknowledged: !1 }, m = { mobileJoystickLookEnabled: !0 }, h = { vrModelOverride: !1 }, g = {
	maximumScreenSpaceError: 12,
	maximumMemoryUsage: 1024
}, _ = {
	low: {
		minPixelSize: 3,
		minContribution: 6,
		splatBudget: 15e5,
		lodRangeMin: 2,
		lodMode: "distance",
		lodFalloff: 2
	},
	medium: {
		minPixelSize: 2,
		minContribution: 3,
		splatBudget: 4e6,
		lodRangeMin: 0,
		lodMode: "distance",
		lodFalloff: 1
	},
	high: {
		minPixelSize: 1,
		minContribution: 1,
		splatBudget: 12e6,
		lodRangeMin: 0,
		lodMode: "distance",
		lodFalloff: 1
	}
}, v = [
	e.iOS,
	e.iPadOS,
	e.Android
], y = () => {
	let { deviceType: e } = t();
	return v.includes(e) ? { ..._.low } : { ..._.medium };
}, b = { ..._.medium }, x = n(i(r((e, t) => ({
	settingsInitialised: !1,
	graphicsSettings: { ...u },
	setGraphicsSettings: (t) => {
		e((e) => ({
			graphicsSettings: {
				...e.graphicsSettings,
				...t
			},
			settingsInitialised: !0
		}));
	},
	enableDefaultAdvancedGraphicsFeatures: () => {
		t().setGraphicsSettings({
			...u,
			...d
		});
	},
	gizmoSettings: { ...f },
	setGizmoSettings: (t) => {
		e((e) => ({
			gizmoSettings: {
				...e.gizmoSettings,
				...t
			},
			settingsInitialised: !0
		}));
	},
	graphicsWarnings: { ...p },
	setGraphicsWarnings: (t) => {
		e((e) => ({
			graphicsWarnings: {
				...e.graphicsWarnings,
				...t
			},
			settingsInitialised: !0
		}));
	},
	setIntelWarningAcknowledged: () => {
		t().setGraphicsWarnings({ intelGraphicsWarningAcknowledged: !0 });
	},
	navigationSettings: { ...m },
	setNavigationSettings: (t) => {
		e((e) => ({
			navigationSettings: {
				...e.navigationSettings,
				...t
			},
			settingsInitialised: !0
		}));
	},
	arModelSettings: { ...h },
	setArModelSettings: (t) => {
		e((e) => ({
			arModelSettings: {
				...e.arModelSettings,
				...t
			},
			settingsInitialised: !0
		}));
	},
	gridVisible: !0,
	setGridVisible: (t) => {
		e(() => ({ gridVisible: t }));
	},
	tiles3dSettings: { ...g },
	setTiles3dSettings: (t) => {
		e((e) => ({
			tiles3dSettings: {
				...e.tiles3dSettings,
				...t
			},
			settingsInitialised: !0
		}));
	},
	gsplatSettings: { ...b },
	setGSplatSettings: (t) => {
		e((e) => ({
			gsplatSettings: {
				...e.gsplatSettings,
				...t
			},
			gsplatSettingsUserSet: !0,
			settingsInitialised: !0
		}));
	},
	gsplatSettingsUserSet: !1,
	applyDeviceDefaultGSplatSettings: () => {
		t().gsplatSettingsUserSet || e(() => ({ gsplatSettings: y() }));
	},
	measurementUnits: "feet",
	setMeasurementUnits: (t) => {
		e(() => ({ measurementUnits: t }));
	}
}), {
	name: s,
	version: c,
	migrate: (e, t) => {
		let n = e;
		for (let e = t; e < c; e++) switch (e) {
			case 1:
				n.graphicsSettings = {
					...n.graphicsSettings,
					renderer: "webgl2"
				};
				break;
			case 2: {
				let e = n.graphicsSettings.antialias;
				n.graphicsSettings = {
					...n.graphicsSettings,
					antialias: e === "fxaa" ? "none" : "msaa2x"
				};
				break;
			}
			case 3:
				n.graphicsSettings = {
					...n.graphicsSettings,
					renderer: "webgpu"
				};
				break;
		}
		return n;
	}
})));
a(x);
//#endregion
export { _ as GSplatQualityPresets, x as localSettingsStore };
